import React from 'react';
import { ArrowBack } from '@mui/icons-material';
import IconButton from 'library/components/buttons/IconButton';
import { useMediaQuery } from '@mui/material';
import theme from 'theme';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function OffsetArrowBack(props: any) {
    return <ArrowBack {...props} style={{ marginLeft: 11, ...props.style }} />;
}

interface BackButtonProps {
    onClick: () => void;
    disabled?: boolean;
}

export default function BackButton({ onClick }: BackButtonProps) {
    const small = useMediaQuery(theme.breakpoints.down('sm'));

    return <IconButton size={small ? 45 : 70} icon={OffsetArrowBack} onClick={onClick} />;
}
